import { NumberFormatInput } from "components/FormControls/NumberFormatInput";
import { RequiredFieldLabel } from "components/FormControls/RequiredFieldLabel";
import { useMessage } from "hooks/intl";
import { get } from "lodash";
import { TransactionCount as TransactionCountType } from "types/segments";
import { formatNumberValue } from "utilities/numbers";
import { BoxElement } from "./BoxElement";
import { useStyles } from "./SegmentConditions.styles";

export const initialValuesTransactionCount: TransactionCountType = {
  min: 0,
  max: 0,
  type: "transaction_count",
};

export function TransactionCount({
  formField,
  values,
  status,
  readOnly,
}: {
  formField: string;
  values: any;
  status: any;
  readOnly?: boolean;
}) {
  const classes = useStyles();
  const { message } = useMessage();
  const value = get(values, formField);
  const minError = get(status, "min");
  const maxError = get(status, "max");

  return (
    <>
      {value.isConditionSaved || readOnly ? (
        <>
          {message({ id: "from" }).toLocaleLowerCase()}
          <BoxElement
            content={formatNumberValue(value?.min, "")}
            error={minError}
          />
          {message({ id: "to" }).toLocaleLowerCase()}
          <BoxElement
            content={formatNumberValue(value?.max, "")}
            error={maxError}
          />
        </>
      ) : (
        <>
          <NumberFormatInput
            allowNegative={false}
            label={
              <RequiredFieldLabel
                text={message({ id: "transactionCountFrom" })}
              />
            }
            name={`${formField}.min`}
            data-test-id="segment-conditions-transaction-count-min-input"
            className={classes.input}
          />
          <NumberFormatInput
            allowNegative={false}
            label={
              <RequiredFieldLabel
                text={message({ id: "transactionCountTo" })}
              />
            }
            name={`${formField}.max`}
            data-test-id="segment-conditions-transaction-count-max-input"
            className={classes.input}
          />
        </>
      )}
    </>
  );
}
